const CONST_SUB_GENRE_FILTER = {
  ALL: -1,
  ONLY: 1,
  NONE_ONLY: 0,
};

const CONST_SUB_DEL_GENRE_FILTER = {
  ALL: -1,
  HIDE_DEL: 1,
  SHOW_DEL: 0,
};

const BACKGROUND_TYPE = {
  COLOR: 0,
  IMG: 1,
};
const objDefault = { CONST_SUB_GENRE_FILTER, BACKGROUND_TYPE, CONST_SUB_DEL_GENRE_FILTER };

export default objDefault;
